// USER ENDPOINTS

export const login = '/user/login';
export const register = '/user/register';
export const createCompaign = '/campaign/create';
export const getCampaignsList = '/campaign/all?time_period=all';
export const getCompaignDetails = '/campaign/get/{id}';
export const extendBudget = '/campaign/extend';

export const getAudioData = '/tiktok/audio/info';
export const getVideoData = '/tiktok/video/info';

export const getUserDetails = '/user/get/{id}';
export const updatePassword = '/user/update-password/{id}';